import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-workslip-statement',
  templateUrl: './workslip-statement.component.html',
  styleUrls: ['./workslip-statement.component.css']
})
export class WorkslipStatementComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/technical/billing/workslip-statement/workslip-statement.component.ts